import { useMemo, useContext } from 'react'
import AddIcon from '@mui/icons-material/Add'
import Button from '@mui/material/Button'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import { useSelector, useDispatch } from 'react-redux'
import { fieldSetContext } from '@contexts'
import * as TemplateActions from '../template.actions'
import { Parameter } from './parameter'
import { t } from '@lingui/core/macro'

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list)
  const [removed] = result.splice(startIndex, 1)
  result.splice(endIndex, 0, removed)
  return result
}

const getItemStyle = (isDragging, draggableStyle) => ({
  userSelect: 'none',
  margin: '10px 0',
  ...draggableStyle,
})

export const Parameters = () => {
  const storeItems = useSelector(state => state.Template.parameters)
  const dispatch = useDispatch()
  const { byId } = useContext(fieldSetContext)
  const fields = useSelector(state => Object.values(state.Template.fieldsById)).map(f => {
    return { value: f.id, label: f.name }
  })
  // need to actually get fieldsets from context...
  const fieldsets = useSelector(state => state.Template.fieldsets).map(fs => {
    return { value: byId[fs.id].id, label: byId[fs.id].name }
  })

  function onDragEnd(result) {
    const newItems = reorder(storeItems, result.source.index, result.destination.index).map(
      (p, index) => ({ ...p, precedence: index }),
    )
    dispatch(TemplateActions.setParameters(newItems))
  }

  const addParameter = () => {
    dispatch(TemplateActions.addParameter())
  }

  return (
    <div style={{ width: '100%' }}>
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="droppable">
          {provided => (
            <div {...provided.droppableProps} ref={provided.innerRef}>
              {storeItems.map((item, index) => (
                <Draggable key={item.id} draggableId={`${item.id}`} index={index}>
                  {(provided, snapshot) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      style={getItemStyle(snapshot.isDragging, provided.draggableProps.style)}
                    >
                      {useMemo(
                        () => (
                          <Parameter
                            parameter={item}
                            key={item.id}
                            fields={fields}
                            fieldsets={fieldsets}
                          />
                        ),
                        [item],
                      )}
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
      <div>
        <Button variant="outlined" color="primary" onClick={addParameter} startIcon={<AddIcon />}>
          {t`Add parameter`}
        </Button>
      </div>
    </div>
  )
}
